"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchPage = void 0;
async function fetchPage(url) {
    return await fetch(url)
        .then((response) => {
        return response.text();
    })
        .catch(error => console.error(error));
}
exports.fetchPage = fetchPage;
